import $$ from 'cmn-utils'
import {downloadExcel} from "@/utils/tool";
import {baseUrl} from "@/utils/constant";

const preUrl = "/api/other/";
export default {
    get: (params) => {
        return $$.get(preUrl + 'get', params)
    },
    post: (params) => {
        return $$.post(preUrl + 'post', params)
    },
    upload: (params) => {
        return $$.post(preUrl + 'upload', params)
    },
    uploadBase64: (params) => {
        return $$.post(preUrl + 'upload-base64', params)
    },
    download: (data) => {
        return $$.get(preUrl + 'download', data, {
            responseType: 'blob',
        })
    },
    downloadAudioStream: (data) => {
        return $$.get(preUrl + 'download-audio-stream', data, {
            responseType: 'blob',
        })
    },
    dlFontIcon: (params) => {
        return $$.get(preUrl + 'dl-font-icon', params)
    },
    dlImage: (params) => {
        return $$.get(preUrl + 'dl-image', params)
    },
    dlProductImage: (params) => {
        return $$.get(preUrl + 'dl-product-image', params)
    },
    iflytekPlayVoice: (params) => {
        return $$.get(preUrl + 'iflytek-play-voice', params)
    },
    updateFontIcon: (params) => {
        return $$.post(preUrl + 'upload-font-icon', params)
    },
    uploadImage: (params) => {
        return $$.post(preUrl + 'upload-image', params)
    },
    uploadImageBase64: (params) => {
        return $$.post(preUrl + 'upload-image-base64', params)
    },
    version: (params) => $$.get(preUrl + 'version', params),
    getAliyunGeo: (params) => $$.get(preUrl + 'get-aliyun-geo', params)

}